$(window).on('load', function() {
  $( ".slide-option-add-on" ).each(function( index ) {
    var show = false;
    var number = Math.floor($(this).width() / 65);
    if($(this).hasClass('color-watches-product')) {
      if($(this).find('.item-slider').length > 2) {
        show = true;
        number = 2;
      }else {
        $(this).removeClass('slide-option-add-on');
      }
    }else {
      if($(this).find('.item-slider').length > number) {
        show = true;
      }else {
        $(this).removeClass('slide-option-add-on');
      }
    }
    if(show) {
      $(this).flickity({
        pageDots: false,
        initialIndex: 0,
        contain: true,
        prevNextButtons: true,
        groupCells: number
      });
    }
  });
  $(".input-required").each(function(){
    if(this.value != "") {
      $(this).removeClass('data-add-on-unselected');
    }else {
      $(this).addClass('data-add-on-unselected');
    }
  });
  $(".input-required").change(function(){
    if(this.value != "") {
      $(this).removeClass('data-add-on-unselected');
    }else {
      $(this).addClass('data-add-on-unselected');
    }
  });
  $(".color-watches").click(function(){
    $(this).parents(".custom-option-main").find(".datachecked").text($(this).data('swatch'));
  });
  $(".color-watches-content-not-product input").each(function(){
    if($(this).is(':checked')) {
      $(this).parents(".custom-option-main").find(".datachecked").text($(this).val());
    }
  });
  $(window).on('resize', function() {
    $( ".slide-option-add-on" ).each(function( index ) {
      var show = false;
      var number = Math.floor($(this).width() / 65);
      if($(this).hasClass('color-watches-product')) {
        if($(this).find('.item-slider').length > 2) {
          show = true;
          number = 2;
        }else {
          $(this).removeClass('slide-option-add-on');
        }
      }else {
        if($(this).find('.item-slider').length > number) {
          show = true;
        }else {
          $(this).removeClass('slide-option-add-on');
        }
      }
      if(show) {
        $(this).flickity({
          pageDots: false,
          initialIndex: 0,
          contain: true,
          prevNextButtons: true,
          groupCells: number
        });
      }
    });
  });
});
$(document)
.on('shopify:section:load', function(e){
  $( ".slide-option-add-on" ).each(function( index ) {
    var show = false;
    var number = Math.floor($(this).width() / 65);
    if($(this).hasClass('color-watches-product')) {
      if($(this).find('.item-slider').length > 2) {
        show = true;
        number = 2;
      }else {
        $(this).removeClass('slide-option-add-on');
      }
    }else {
      if($(this).find('.item-slider').length > number) {
        show = true;
      }else {
        $(this).removeClass('slide-option-add-on');
      }
    }
    if(show) {
      $(this).flickity({
        pageDots: false,
        initialIndex: 0,
        contain: true,
        prevNextButtons: true,
        groupCells: number
      });
    }
  });
  $(".input-required").each(function(){
    if(this.value != "") {
      $(this).removeClass('data-add-on-unselected');
    }else {
      $(this).addClass('data-add-on-unselected');
    }
  });
  $(".input-required").change(function(){
    if(this.value != "") {
      $(this).removeClass('data-add-on-unselected');
    }else {
      $(this).addClass('data-add-on-unselected');
    }
  });
  $(".color-watches").click(function(){
    $(this).parents(".custom-option-main").find(".datachecked").text($(this).data('swatch'));
  });
  $(".color-watches-content-not-product input").each(function(){
    if($(this).is(':checked')) {
      $(this).parents(".custom-option-main").find(".datachecked").text($(this).val());
    }
  });
  $(window).on('resize', function() {
    $( ".slide-option-add-on" ).each(function( index ) {
      var show = false;
      var number = Math.floor($(this).width() / 65);
      if($(this).hasClass('color-watches-product')) {
        if($(this).find('.item-slider').length > 2) {
          show = true;
          number = 2;
        }else {
          $(this).removeClass('slide-option-add-on');
        }
      }else {
        if($(this).find('.item-slider').length > number) {
          show = true;
        }else {
          $(this).removeClass('slide-option-add-on');
        }
      }
      if(show) {
        $(this).flickity({
          pageDots: false,
          initialIndex: 0,
          contain: true,
          prevNextButtons: true,
          groupCells: number
        });
      }
    });
  });
});